import { UserOnboardingSchema } from "@redotech/redo-onboarding-common/user-onboarding";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getUserOnboarding = {
  name: "getUserOnboarding" as const,
  input: z.null(),
  output: zExt.filterToValidArray(UserOnboardingSchema),
};
